<template>
    <div class="pay">
        <el-dialog title="服务订购" :visible.sync="dialogVisible" width="1048px" :before-close="handleClose">
            <div class="content scroll-auto">
                <div class="main" v-if="itemData">
                    <el-steps :space="200" :active="1" finish-status="success" align-center>
                        <el-step title="选择服务"></el-step>
                        <el-step title="确认账单"></el-step>
                        <el-step title="确认付款"></el-step>
                        <el-step title="完成订购"></el-step>
                    </el-steps>
                    <el-table :data="itemData.service" style="width: 100%">
                        <el-table-column align="center" prop="name" label="服务名称"> </el-table-column>
                        <el-table-column align="center" prop="amount" label="服务时长">
                            <template>
                                {{
                                    itemData.time_option == "0_0"
                                        ? "未设置"
                                        : itemData.time_option == "1_year"
                                        ? "1年"
                                        : itemData.time_option == "3_month"
                                        ? "3个月"
                                        : itemData.time_option == "1_month"
                                        ? "1个月"
                                        : "-"
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="amount" label="服务价格 (元)"> </el-table-column>
                    </el-table>
                    <p class="pay">
                        应支付：<span>{{ itemData.amount || 0 }}</span> 元
                    </p>
                    <el-button :type="!checked ? 'info' : 'success'" :disabled="!checked" @click="step1">立即支付</el-button>
                    <el-checkbox v-model="checked">阅读并同意 <el-link type="primary">《用户服务协议》</el-link> </el-checkbox>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <p>合计： <span>5555.00</span> 元</p>
                <el-button type="primary" @click="dialogVisible = false">下一步</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "PayDia",
    data() {
        return {
            checked: false,
            dialogVisible: false,
        };
    },
    props: ["itemData"],
    methods: {
        step1(itemData) {
       /*    if (itemData.amount==0) {
              this.dialogVisible= false
            this.$router.push('/home/detection') 
          } */
          
            this.$emit("step1", itemData);

        },
        handleClose() {
            this.checked = false;
            this.dialogVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    height: 550px;
}
.main {
    margin: 40px 80px;
    .el-steps {
        margin-bottom: 40px;
    }
    .el-button {
        display: block;
        margin-bottom: 22px;
    }
    .pay {
        margin: 22px 0;
        color: #333;
        font-size: 14px;
        font-weight: 600;
        span {
            color: #f42727;
            font-size: 20px;
        }
    }
    .list {
        display: flex;
        .item {
            margin: 20px;
            flex: 1;
            background: #ffffff;
            border: 1px solid #d4d4d4;
            border-radius: 2px;
        }
    }
}
::v-deep .el-table th.el-table__cell {
    background-color: rgb(249, 249, 251);
}
::v-deep .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p {
        margin-right: 40px;
        span {
            color: red;
        }
    }
}
::v-deep .el-dialog__body {
    padding: 0;
}
</style>